import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSeller = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19 1.65452C19 1.24462 18.658 0.99954 18.3029 1C17.7344 1.00074 16.0685 1.00271 10.3939 1.00378C6.48849 1.00452 4.60452 1.0032 3.71296 1.00197C3.14221 1.00118 2.67821 1.45579 2.67821 2.02208L2.67376 17.6222H1.69405C1.31091 17.6222 1.00057 17.929 1 18.3078C0.999432 18.6866 1.30901 18.9955 1.69263 18.9973C1.98426 18.9985 2.58701 19 4.18938 19C5.796 19 6.35973 18.9985 6.62868 18.9972C7.01947 18.9954 7.32116 18.6699 7.32116 18.2992C7.32116 17.9123 7.00273 17.6222 6.62723 17.6222H4.0278L4.03224 2.37724H5.44237L6.43937 2.38012H8.04535V4.44364H6.19661C5.68165 4.44364 5.25515 4.81672 5.17796 5.30472C5.16972 5.35674 5.1655 5.40992 5.16553 5.46391C5.16625 6.58793 5.16842 7.71193 5.17059 8.83573V8.83654V8.83737L5.17305 10.152C5.17424 10.8381 5.17522 11.5242 5.17566 12.2102C5.17602 12.7734 5.63763 13.2301 6.20726 13.2301H17.9058C18.4764 13.2301 18.9352 12.7725 18.9352 12.21V5.46374C18.9352 4.90036 18.4735 4.44364 17.9039 4.44364H16.0704V2.38012H18.3036C18.7159 2.38012 19 2.006 19 1.65452ZM9.3994 4.44364V2.38012H14.7164V4.44364H9.3994ZM6.51248 11.8523V5.82149H17.6033V11.8523H6.51248Z",
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: .5
	})
});
export default SvgSeller;
